import React from "react";
import {IconDocumentLinesCircle} from "../../../../../../components/buttons/IconButtons";

import {
    MOVEMENT_DIRECTION_DATE_DEFAULTS,
    MOVEMENT_DIRECTION_FIELD_DEFAULTS,
    MOVEMENT_DIRECTION_SECTION_DEFAULTS,
    getMovementDirectionSection
} from "../../../Model/Model";
import CustomUserChip from "../../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import MovementDirectionSection from "../PlantMaterialControl/MovementDirectionSection";
import DepartureSection from "../PlantMaterialControl/DepartureSection";
import LivePoultryTruckTransportSection from "./LivePoultryTruckTransportSection";
import LivePoultryTruckMovementSection from "./LivePoultryTruckMovementSection";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @description
 * Renders the sections of a live poultry truck form: the direction of the
 * movement with the section it enables, the transport that carries the live
 * poultry and the date on which the movement is expected. The vehicle is
 * captured at the gate, so its fields are optional for the requester.
 *
 * @param {Function} t - Translation function.
 * @param {Function} handleChange - Change handler of the form.
 * @param {Object} materialRequest - Current form information.
 * @param {Function} setMaterialRequest - Updates the current form information.
 * @param {boolean} emptyFields - Indicates whether the required fields must be highlighted.
 */
const LivePoultryTruckSections = ({
    t,
    handleChange,
    materialRequest,
    setMaterialRequest,
    emptyFields
}) => {

    const selectedDirectionSection = getMovementDirectionSection(materialRequest?.movementDirection);

    /**
     * Sets the movement direction of the form.
     *
     * When the direction changes, every field enabled by the previous direction
     * is restored to its default value, so the information captured for it is
     * neither displayed nor submitted.
     *
     * @param {number} movementDirection - Selected movement direction.
     *
     * @returns {void}
     */
    const handleSelectMovementDirection = (movementDirection) => {
        if (materialRequest?.movementDirection === movementDirection)
            return;

        setMaterialRequest((prev) => ({
            ...prev,
            ...MOVEMENT_DIRECTION_DATE_DEFAULTS,
            ...MOVEMENT_DIRECTION_SECTION_DEFAULTS,
            ...MOVEMENT_DIRECTION_FIELD_DEFAULTS,
            movementDirection,
        }));
    };

    return (
        <>
            <MovementDirectionSection
                t={t}
                idPrefix={"lpt"}
                materialRequest={materialRequest}
                onSelectDirection={handleSelectMovementDirection}
                emptyFields={emptyFields}
            >
                { selectedDirectionSection &&
                <DepartureSection
                    t={t}
                    section={selectedDirectionSection}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                />
                }
            </MovementDirectionSection>

            <div className='col-12 py-3 mt-3 border-radius-8px background-secondary-50 border-dashed-secondary-150'>
                <CustomUserChip
                    className='m-0 p-0 chip-secondary-150-100 justify-content-start d-flex w-100'
                    name={t('any_field_you_leave_blank_will_be_completed_by_the_guard_at_the_gate')}
                    Icon={IconDocumentLinesCircle}
                    showAvatar={true}
                    classNameIcon={'icon-color-secondary-700'}
                    variant='large'
                    iconPosition={POSITION_MODEL.LEFT}
                />

                <LivePoultryTruckTransportSection
                    t={t}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                />

                <LivePoultryTruckMovementSection
                    t={t}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    required={false}
                    disablePast={true}
                />
            </div>
        </>

    );
};

export default LivePoultryTruckSections;
